import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 901A06AA-7C77-43B3-90CD-10B329C42DB7
 * name surround-sound-2-1
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/surround-sound-2-1.svg
 * tags
 */
export const SurroundSound21Icon = createSvgIcon(<><path d="M4 7V9H8V11H6C4.9 11 4 11.9 4 13V17H10V15H6V13H8C9.1 13 10 12.1 10 11V9C10 7.9 9.1 7 8 7H4M14 17H12V15H14V17M16 7V9H18V17H20V7H16Z" /></>, 'SurroundSound21Icon');
export default SurroundSound21Icon